import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=57bc2b0e&scoped=true"
import script from "./Credit.vue?vue&type=script&lang=js"
export * from "./Credit.vue?vue&type=script&lang=js"
import style0 from "./Credit.vue?vue&type=style&index=0&id=57bc2b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bc2b0e",
  null
  
)

export default component.exports